/* eslint-disable import/no-named-as-default */
/* eslint-disable no-shadow */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import { connect } from "react-redux";
import { loadActivityFeed } from "../../../actions/activityFeedActions";
import Wrapper from "./styles/activity-feed-styles";

const ActivityFeedMobile = ({ loadActivityFeed }) => {
  const handleClick = () => {
    const activityFeed = document.getElementById("activity-feed");

    loadActivityFeed();
    activityFeed.classList.toggle("active");
  };

  return (
    <Fragment>
      <Wrapper onClick={() => handleClick()}>
        <FontAwesomeIcon icon={faGlobe} />
      </Wrapper>
    </Fragment>
  );
};

ActivityFeedMobile.propTypes = {
  loadActivityFeed: PropTypes.func.isRequired,
};

export default connect(null, { loadActivityFeed })(ActivityFeedMobile);
